import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IDeleteFavoriteChannelsUseCase {
    execute(apiKey: string, profileGuid: string, ids: string[], token: string, identityToken: string): Promise<any>;
}

export class DeleteFavoriteChannelsUseCase implements IDeleteFavoriteChannelsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        profileGuid: string,
        ids: string[],
        token: string,
        identityToken: string
    ): Promise<any> {
        const id = ids.join(',');
        const result = await this.profileRepository.deleteFavoriteChannels(
            apiKey,
            profileGuid,
            id,
            token,
            identityToken
        );
        return result.data.code === 'accepted';
    }
}
